import { dispatch, getState } from '../../..';
import PumpingStationFlowmeterSizeHelper, { IPumpingStationFlowmeterSize } from '../../../../@types/model/masterData/pumpingStation/flowmeterSize';
import GeneralFunctions from '../../../general/functions';
import MasterDataPumpingStationFlowmeterSizeActions from './actions';

export default class MasterDataPumpingStationFlowmeterSizeFunctions {
    private static listener : undefined | (() => void);


    public static readonly load = async () => {
        if (MasterDataPumpingStationFlowmeterSizeFunctions.listener) return;
        
        dispatch(MasterDataPumpingStationFlowmeterSizeActions.setLoading(true));
        dispatch(MasterDataPumpingStationFlowmeterSizeActions.set([]));

        try {
            MasterDataPumpingStationFlowmeterSizeFunctions.listener = PumpingStationFlowmeterSizeHelper
                .collection()
                .onSnapshot((snapshot : firebase.firestore.QuerySnapshot<IPumpingStationFlowmeterSize>) => {
                    const state = getState().masterData.pumpingStation.flowmeterSize;

                    const list = state.flowmeterSizes.slice();
                
                    const session = getState().auth.session;
                    if (!session) return;

                    // "added" | "removed" | "modified"
                    snapshot.docChanges().forEach((f) => {
                        const item = f.doc.data();
                        const index = list.findIndex(n => n.id === item.id);


                        switch (f.type) {
                            case 'added':
                                list.push(item);
                                break;
                            case 'modified':
                                list.splice(index, 1, item);
                                break;
                            case 'removed':
                                list.splice(index, 1);
                                break;
                        }
                    });

                    dispatch(MasterDataPumpingStationFlowmeterSizeActions.set(list));
                    dispatch(MasterDataPumpingStationFlowmeterSizeActions.setLoading(false));
                }, (ex) => {
                    GeneralFunctions.generalShowError(ex, 'Error loading pumps.');
                    dispatch(MasterDataPumpingStationFlowmeterSizeActions.setLoading(false));
                }, () => {
                    dispatch(MasterDataPumpingStationFlowmeterSizeActions.setLoading(false));
                    MasterDataPumpingStationFlowmeterSizeFunctions.listener = undefined;
                });

        } catch (ex) {
            GeneralFunctions.generalShowError(ex, 'Error loading pumps.');
            dispatch(MasterDataPumpingStationFlowmeterSizeActions.setLoading(false));
        }
    };
}